import styled from 'styled-components';
import tokens from '@quintoandar/cozy-theme/tokens/js';

const UploadInputWrapper = styled.div`
  position: relative;
  border-radius: ${tokens.alias.shape.border.radius.sharp};

  input {
    width: 0.1px;
    height: 0.1px;
    overflow: hidden;
    position: absolute;
    z-index: ${tokens.alias?.zIndex.low};
    &:focus-visible {
      box-shadow: none;
    }
  }

  label:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
  }

  input:focus-visible + label:after {
    border-radius: ${tokens.alias.shape.border.radius.sharp};
    box-shadow: ${tokens.focusVisible.color.border} 0px 0px 0px 2px;
  }
`;

export default UploadInputWrapper;
